import {Box, Show, Stack} from 'platform/foundation';

import {defaultTo} from 'ramda';

import {testIds} from '@dms/routes';
import {usePermissions} from '@dms/shared';
import {TaskCenterCard} from '@dms/task-manager';

import {useDashboardWidgetSettings} from '../hooks/useDashboardWidgetSettings';
import {MyNotifications} from './MyNotifications';

const defaultToFalse = defaultTo(false);

// The combined tile of the dashboard without customisation, kept as it was before the quarter grid.
// Remove it together with the DASHBOARD_CUSTOMISATION flag.
export function TasksAndNotifications() {
  const userDashboardSettings = useDashboardWidgetSettings();

  const [canReadTasks] = usePermissions({
    permissionKeys: ['readTask'],
  });

  const isTasksShown = canReadTasks && defaultToFalse(userDashboardSettings?.myTasks);
  const isNotificationsShown = defaultToFalse(userDashboardSettings?.notifications);

  return (
    <Stack
      width="100%"
      height="100%"
      spacing={4}
      justify="stretch"
      direction={['column', 'column', 'row', 'row']}
    >
      <Show when={isTasksShown}>
        <Box
          width={['100%', undefined]}
          height={[undefined, undefined, '100%', '100%']}
          flexGrow={[undefined, 1]}
        >
          <TaskCenterCard isFullHeight data-testid={testIds.dashboard.home('tasks')} />
        </Box>
      </Show>
      {/* Beside the tasks the notifications keep to their half; alone they fill the tile like the tasks do. */}
      <Show when={isNotificationsShown}>
        <Box
          width={['100%', undefined]}
          height={[undefined, undefined, '100%', '100%']}
          flexGrow={[undefined, 1]}
          maxWidth={isTasksShown ? [undefined, undefined, '50%', '50%'] : undefined}
          data-testid={testIds.dashboard.home('notifications')}
        >
          <MyNotifications size="quarter" />
        </Box>
      </Show>
    </Stack>
  );
}
